import React, { useState } from "react";
import "./header.scss";
import Logo from "../../assets/logo.svg";
import useAuth from "../../controller/auth-controller";
import { getNameFirstLetter, getUserData } from "../../utils/helper";
import { useDialogContext } from "../dialogs/Dialog";
import Tooltip from "rc-tooltip";

const Header = () => {
  const authController = useAuth();
  const userData = getUserData();
  const { logout } = authController;
  const { dispatch } = useDialogContext();
  const [profileMenu, setProfileMenu] = useState(false);

  const changePassword = () => {
    dispatch({
      type: "openDialog",
      payload: {
        data: {
          modalType: "changePassword",
          title: "Change Password",
          className: "md:px-0 px-4 pb-0",
        },
        path: `change-password/ChangePassword`,
      },
    });
  };

  return (
    <>
      <div
        className={`md:flex hidden header p-2 z-12 flex items-center justify-between fixed top-0	w-full`}
      >
        <div className={`flex w-full h-full items-center justify-between`}>
          <img src={Logo} className="header-logo" alt="logo-icon" />
          <div className="flex items-center relative">
            <Tooltip
              trigger={`click`}
              onVisibleChange={(data) => setProfileMenu(data)}
              placement="bottomRight"
              overlay={
                <div className="p-0 m-0" role="none">
                  {/* <a
                    href="#"
                    className="text-black-100 text-base block px-4 py-3 cursor-pointer text-center border-b-2"
                    role="menuitem"
                    tabindex="-1"
                    id="menu-item-0"
                  >
                    My Profile
                  </a> */}
                  <a
                    onClick={changePassword}
                    className="text-black-100 text-base block px-4 py-3 cursor-pointer text-center border-b-2"
                    role="menuitem"
                    tabindex="-1"
                  >
                    Change Password
                  </a>
                  <a
                    className="text-black-100 text-base block px-4 py-3 cursor-pointer text-center"
                    role="menuitem"
                    tabindex="-1"
                    id="menu-item-2"
                    onClick={() => logout()}
                  >
                    Logout
                  </a>
                </div>
              }
              overlayClassName="w-[180px] opacity-100 pageheader-tooltip"
              overlayInnerStyle={{
                backgroundColor: "#F4F3F4",
                left: "100%",
                borderRadius: "4px",
              }}
            >
              <div className="flex items-center pe-3 profilehover cursor-pointer">
                <div className="rounded-full mr-2 bg-primary text-white-100 w-10 h-10  flex justify-center items-center">
                  {getNameFirstLetter(userData?.fsoName || "D")}
                </div>
                <span className="me-2">{userData?.fsoName}</span>
                <div>
                  {profileMenu ? (
                    <svg
                      height="20"
                      width="20"
                      viewBox="0 0 20 20"
                      aria-hidden="true"
                      focusable="false"
                      className="css-tj5bde-Svg rotate-180"
                    >
                      <path d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path>
                    </svg>
                  ) : (
                    <svg
                      height="20"
                      width="20"
                      viewBox="0 0 20 20"
                      aria-hidden="true"
                      focusable="false"
                      className="css-tj5bde-Svg"
                    >
                      <path d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path>
                    </svg>
                  )}
                </div>
              </div>
            </Tooltip>
          </div>
        </div>
      </div>
    </>
  );
};
export default Header;
